// Get the language switch items
const languageSwitches = document.querySelectorAll('.language-switch select');

if (languageSwitches) {
    // Loop through each language switch
    languageSwitches.forEach(languageSwitch => {
        // Listen for change event
        languageSwitch.addEventListener('change', (e) => {
            // Get the value
            const target = e.target.value;
            // If the value is not empty, redirect user to target URL
            if (target) window.location.href = target;
        });
    });
}